<!--
    描述：roleLimit
    时间：2021-03-26
    Created by sjq
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>按钮列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   @click="saveClick">保存</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="btnContent"
						 style=" overflow-y: auto; border:1px solid #eee">
						<el-tree ref="btnTree"
								 :data="btnTreeData"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 :check-strictly="true"
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"
								 @check="treeCheck"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: {
		list: {
            type: Array,
            default: () => {
                return []
            }
        },

		value: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	data() {
		return {
			btnTreeData: [],
			defaultProps: {
				children: 'children',
				label: 'sname'
			},
			treeDefaultCheckedKey: []
		}
	},
	methods: {
		treeCheck(data, node) {
			this.$emit('input', node.checkedKeys)
		},

		// 保存
		saveClick() {
			this.$emit('save')
		},

		// 设置tree点击状态
		setTreeChecked() {
			this.treeDefaultCheckedKey = []
			this.btnTreeData.map(i => {
				if (i.isChecked) {
					this.treeDefaultCheckedKey.push(i.id)
				}
			})
		}
	},
	watch: {
		list(val) {
            this.btnTreeData = val
			this.setTreeChecked()
        }
	}
}
</script>

<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}
.w-table-page {
	padding-bottom: 5px;
}
</style>
